<template>
    <div>
        <div class="card">
            <div class="card-header">反馈问卷信息</div>
            <table class="table table-bordered mb-0" v-if="surveyPaperInfo">
                <tbody>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">应评</th>
                    <td class="text-left align-middle" style="width: 15%">{{surveyData.length}}</td>
                    <th class="text-center align-middle" style="width: 10%">实评</th>
                    <td class="text-left align-middle" style="width: 15%">{{surveyPaperInfo.submitStudentCount}}</td>
                    <th class="text-center align-middle" style="width: 10%">评分</th>
                    <td class="text-left align-middle" style="width: 15%">{{surveyPaperInfo.surveyScore}}</td>
                    <th class="text-center align-middle" style="width: 10%">状态</th>
                    <td class="text-left align-middle" style="width: 15%">{{surveyPaperInfo.stateName}}</td>
                </tr>
                <tr v-for="(item, index) in surveyScoreListData" :key="index">
                    <td class="text-center">{{index+1}}</td>
                    <td class="text-left" colspan="6">{{item.title}}</td>
                    <td class="text-center">{{item.avgScore}}</td>
                </tr>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">评价<br />内容</th>
                    <td class="text-left align-middle" colspan="7">
                        <div v-if="surveyPaperInfo.surveyContentObject &&
                                    surveyPaperInfo.surveyContentObject.lowScoreContent &&
                                    surveyPaperInfo.surveyContentObject.lowScoreContent.length!==0">
                            <p class="font-weight-bold">客观项低分原因：</p>
                            <ul class="">
                                <li v-for="item in surveyPaperInfo.surveyContentObject.lowScoreContent">
                                    <div>
                                        <p class="mb-0">{{ item.title }}</p>
                                        <p class="mb-0">{{ item.content }}<template v-if="canViewDetail">  —— {{item.studentName}} {{item.collegeName}}</template></p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div v-if="surveyPaperInfo.surveyContentObject && surveyPaperInfo.surveyContentObject.content && surveyPaperInfo.surveyContentObject.length!==0">
                            <p class="font-weight-bold">主观评价项评价内容：</p>
                            <ul class="mb-0">
                                <li v-for="item in surveyPaperInfo.surveyContentObject.content">
                                    <div>
                                        <p class="font-weight-bold">{{item.title}}</p>
                                        <ul>
                                            <li v-for="s in item.contentData">
                                                {{ s.content }}<template v-if="canViewDetail">  —— {{s.studentName}} {{s.collegeName}}</template>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="8" class="text-danger">注：各评分项按所有反馈成绩取平均值计算</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="card mt-3" v-if="canViewDetail">
            <div class="card-header">反馈详情</div>
            <table class="table table-bordered mb-0">
                <thead>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">序号</th>
                    <th class="text-center align-middle" style="width: 10%">姓名</th>
                    <th class="text-center align-middle" style="width: 40%">所属院校</th>
                    <th class="text-center align-middle" style="width: 10%">反馈</th>
                    <th class="text-center align-middle" style="width: 20%">反馈时间</th>
                    <th class="text-center align-middle" style="width: 10%">详情</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in surveyData">
                    <td class="text-center align-middle">{{index+1}}</td>
                    <td class="text-center align-middle">{{item.studentName}}</td>
                    <td class="text-left align-middle">{{item.collegeName}}</td>
                    <td class="text-center align-middle">{{item.surveyScore}}</td>
                    <td class="text-center align-middle">{{item.createDateTimeString}}</td>
                    <td class="text-center align-middle">
                        <button class="btn btn-info btn-sm" @click="btnShowSurveyDetailInfo_Click(item.surveyId)" :disabled="!item.surveyId">详情</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <b-modal v-model="isSurveyDetailViewDialogOpen"
                 title="参训教师反馈问卷信息详情" size="lg"
                 :hide-footer="true"
                 :no-close-on-backdrop="true">
            <survey-detail-view :survey-id="currentSurveyId"></survey-detail-view>
        </b-modal>
    </div>
</template>

<script>
import studyApi from "@/utils/api/study";
import SurveyDetailView from "@/components/study/SurveyDetailView";
import dictionary from "@/utils/dictionary";

export default {
    name: "SurveyPaperDetailView",
    components: {SurveyDetailView},
    props: {
        surveyPaperId: {type: String, required: true},
        classId: {type: String, required: true},
    },
    data: function () {
        return {
            surveyPaperInfo: {},

            surveyData: [],

            currentSurveyId: '',
            isSurveyDetailViewDialogOpen: false,
        };
    },
    computed: {
        canViewDetail() {
            return this.$store.state.userType === dictionary.userType.ADMIN;
        },

        surveyScoreListData() {
            let result = [];
            let count = 0;

            for (let item of this.surveyData) {
                if (item.scoreItems) {
                    if (result.length === 0) {
                        result = item.scoreItems;
                    }
                    else {
                        for (let index in item.scoreItems) {
                            result[index].score += item.scoreItems[index].score;
                        }
                    }
                    count++;
                }
            }

            for (let index in result) {
                result[index].avgScore = Math.round(100 * result[index].score / count) /100;
            }

            return result;
        }
    },
    mounted() {
        this.getSurveyPaperInfo();
        this.getSurveyData();
    },
    methods: {
        getSurveyPaperInfo() {
            studyApi.survey.paper.getSurveyPaperInfo(this.surveyPaperId).then(res => {
                let data = res.data;
                data.surveyContentObject = JSON.parse(data.surveyContent);

                this.surveyPaperInfo = data;
            });
        },

        getSurveyData() {
            studyApi.survey.getSurveyData(this.surveyPaperId, this.classId).then(res => {
                let result = res.data;
                for (let item of result) {
                    item.scoreItems = JSON.parse(item.scoreDetail);
                    item.contentItems = JSON.parse(item.contentDetail);
                }
                this.surveyData = result;
            });
        },

        btnShowSurveyDetailInfo_Click(surveyId) {
            this.currentSurveyId = surveyId;
            this.isSurveyDetailViewDialogOpen = true;
        }
    }
}
</script>

<style scoped>

</style>